import { Component, OnInit, Inject, Output, EventEmitter } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { formatDate } from '@angular/common';
import { NurseAssessmentService } from 'src/app/services/NurseAssessmentService';
import { NurseAssessmentModel } from 'src/app/models/NurseAssessmentModel';
import swal from 'sweetalert2';
import { LocalStorageService } from 'ngx-webstorage';
import { CompanyModel } from 'src/app/models/CompanyModel';
import { CompanyService } from 'src/app/services/CompanyService';

@Component({
  selector: 'app-nursing-assessment-entry',
  templateUrl: './nursing-assessment-entry.component.html',
  styleUrls: ['./nursing-assessment-entry.component.css']
})
export class NursingAssessmentEntryComponent implements OnInit {
  patientcode = '' ;
  visitdate =formatDate(new Date(), 'yyyy-MM-dd', 'en');
  nursetime =formatDate(new Date(), 'HH:mm', 'en');

  visitlocation = '1' ;
  weight = '' ;
  height = '' ;
  pressure = '' ;
  pulse = '' ;
  temp = '' ;
  nursenote = '' ;
  paconsent = ''
  userid ='';
  patientname = ''
  step = 0;
  patdate = formatDate(new Date(), 'yyyy-MM-dd', 'en');
  visdate = formatDate(new Date(), 'yyyy-MM-dd', 'en');
  patientConsent = false;
  wk_color = 'rgb(159, 0, 0)';
  companyList : CompanyModel[]=[];

  @Output() submitClicked = new EventEmitter<any>();
  setStep(index: number) {
    this.step = index;
  }

  nextStep() {
    this.step++;
  }

  prevStep() {
    this.step--;
  }

  constructor(public nurseassessmentService : NurseAssessmentService,
    public nursassessment : NurseAssessmentModel,
    public storage: LocalStorageService,
    public companyService : CompanyService,
    public dialogRef: MatDialogRef<NursingAssessmentEntryComponent>,
     @Inject(MAT_DIALOG_DATA) public data :any,) {
    this.patientcode = data.patientid;
    this.patientname = data.patientname;
    this.visdate = formatDate(data.nursedate, 'yyyy-MM-dd', 'en');
    this.patdate = formatDate(data.nursedate, 'yyyy-MM-dd', 'en');
  }

  ngOnInit(): void {
        this.RetriveData();
        this.retriveCompanyLookupTop();
        this.visitlocation = this.storage.retrieve('stgLocation');
  }
  Change_color(){
      if(this.patientConsent == true){this.wk_color = 'rgb(0, 134, 40)'}else{this.wk_color = 'rgb(159, 0, 0)'}
  }
  retriveCompanyLookupTop() {
    this.companyService.getLocationLookupTop('1').subscribe((data: CompanyModel[]) => {
        for (let i = 0; i < data.length; i++) {
          this.companyList[i] = data[i];
        }

      });
  }
  RetriveData(){
    this.nurseassessmentService.GetNurseAssessment(this.patientcode, this.visdate).subscribe({
      next: (data: NurseAssessmentModel) => {
        this.visitlocation = data.visitlocation;
        this.visitdate = data.visitdate;
        this.weight = data.weight;
        this.height = data.height;
        this.pressure = data.pressure;
        this.pulse = data.pulse;
        this.temp = data.temp;
        this.nursenote = data.nursenote;
        if(data.paconsent == 'True'){this.patientConsent = true}else{this.patientConsent =false}
        this.Change_color();
        this.userid = data.userid;
        this.RetriveNursing();
      },
      error: (error) => {
        // Handle any actual errors here, if needed.  For example:
        console.error("Error fetching nurse assessment:", error);
        // You might also want to display an error message to the user.
      },
      complete: () => {
        // This block executes after a successful completion (even if data is null/undefined).
          if (!this.visitlocation) {  // Check if visitlocation is undefined or null.  Could also check for an empty string "" if that's a possibility.
              this.visitlocation = '1';
              this.visitdate = formatDate(this.visitdate, 'yyyy-MM-dd', 'en');
          }
      }
    });
  }
  RetriveNursing(){
    //this.nurseassesseList = [];
     this.nurseassessmentService.getNurseAssessmentLookup(this.patientcode).subscribe((data: NurseAssessmentModel[]) => {
        for (let i = 0; i < data.length; i++) {
          if (data[i].paconsent == 'True' ){this.patientConsent = true;this.wk_color = 'rgb(0, 134, 40)'};
        }
      })
  }

  Save_Data(){
    const str1 = formatDate(this.visdate, 'yyyy-MM-dd', 'en') + 'T' +this.nursetime+':00.000Z';
      this.nursassessment.patientcode = this.patientcode;

      this.nursassessment.nursetime = str1; // formatDate(this.resTime, 'HH:mm', 'en') ;
      this.nursassessment.visitlocation = this.visitlocation;
      this.nursassessment.weight = this.weight;
      this.nursassessment.height = this.height;
      this.nursassessment.pressure = this.pressure;
      this.nursassessment.pulse = this.pulse;
      this.nursassessment.temp = this.temp;
      this.nursassessment.nursenote = this.nursenote;
      if(this.patientConsent == true){this.nursassessment.paconsent ='True'}else{this.nursassessment.paconsent ='False'}
      this.nursassessment.userid = this.storage.retrieve('stguserId');

      this.nursassessment.visitdate = formatDate(this.visdate, 'yyyy-MM-dd', 'en');
      this.nurseassessmentService.AddNurseAssessment(this.nursassessment).subscribe(
        (data) => {

          this.mesgSave();

        },
        (error) => {
          alert(error);
        }
      );


  }
    mesgSave() {
      swal({
        title: 'Your work has been saved',
        type: 'success',
        showConfirmButton: false,

        timer: 1500,
      });
    }
    Close_Data(){
     this.dialogRef.close();
    }
}
